<template>
  <form-wrapper :validator="$v">

    <div
      v-for="(item, index) in tuzemskePar5"
      :key="item.id">
      <tuz-item
        v-if="!item.deleted"
        :index="parseInt(index)"
        :tuzemske-par5="tuzemskePar5"
        @del="del(item)"
      />
    </div>

    <buttons
      :add-row="addNewPrijemForm"
      :save="save"
    />

  </form-wrapper>
</template>

<script>
import { minValue, maxValue, decimal } from 'vuelidate/lib/validators'
import restEditor from '@/mixins/restEditor'
import buttons from '@/components/buttons.vue'
import tuzItem from './items/tuzItem.vue'

function tuzPar5Data (parent) {
  return {
    deleted: false,
    id: null,
    parent,
    prijmy_pp: '',
    pr_dohoda: '',
    soc_poist: '',
    zdrav_poist: '',
    bonus: '',
    dan35: ''
  }
}

export default {
  validations: {
    tuzemskePar5: {
      $each: {
        deleted: {},
        prijmy_pp: {
          decimal,
          maxValue: maxValue(999999.99),
          minValue: minValue(0)
        },
        pr_dohoda: {
          decimal,
          maxValue: maxValue(999999.99),
          minValue: minValue(0)
        },
        soc_poist: {
          decimal,
          maxValue: maxValue(999999.99),
          minValue: minValue(0)
        },
        zdrav_poist: {
          decimal,
          maxValue: maxValue(999999.99),
          minValue: minValue(0)
        },
        bonus: {
          decimal,
          maxValue: maxValue(999999.99),
          minValue: minValue(0)
        },
        dan35: {
          decimal,
          maxValue: maxValue(999999.99),
          minValue: minValue(0)
        }
      }
    }
  },

  components: {
    tuzItem,
    buttons
  },

  mixins: [restEditor],

  data() {
    const id = this.$route.params.userId
    return {
      id,
      parent: this.$route.params.userId,
      tuzemskePar5: [tuzPar5Data(id)]
    }
  },

  inject: ['restDataSource', 'eventBus'],

  computed: {
    prijmyBiggerThanVydavky () {
      const prijmy = this.tuzemskePar5.filter(item => item.prijmy_pp && !item.deleted)
      let sumPrijmy = 0

      prijmy.forEach(item => {
        sumPrijmy = Number(sumPrijmy) + Number(item.prijmy_pp)
      })

      const vydavky = this.tuzemskePar5.filter(item => (item.soc_poist || item.zdrav_poist || item.bonus || item.dan35) && !item.deleted)
      let sumVydavky = 0

      vydavky.forEach(item => {
        sumVydavky = Number(sumVydavky) + Number(item.soc_poist) + Number(item.zdrav_poist) + Number(item.bonus) + Number(item.dan35)
      })

      return Number(sumPrijmy) >= Number(sumVydavky)
    }
  },

  methods: {
    async processSave () {
      if (!this.prijmyBiggerThanVydavky) {
        this.eventBus.$emit('httpError', 'Príjmy musia byť väčšie ako výdavky!')
        this.$store.commit('noToast')
        return
      }

      this.tuzemskePar5.forEach(async (data) => {
        const item = data
        if (item.deleted) {
          // delete existing item
          if (item.id) {
            await this.restDataSource.deleteData(item, 'par5inland')
          }
          return
        }

        if (item.id) {
          await this.restDataSource.updateData(item, 'par5inland')
        } else {
          item.id = (await this.restDataSource.createData(item, 'par5inland')).id
        }
      })
      this.tuzemskePar5 = this.tuzemskePar5.filter(item => !item.deleted)
    },

    addNewPrijemForm () {
      this.tuzemskePar5.push(tuzPar5Data(this.id))
    },

    async processGet () {
      const data = await this.restDataSource.getItems(this.parent, 'par5inland')
      if (data.items.length) {
        this.tuzemskePar5 = []
      }
      data.items.forEach((item) => {
        const newItem = tuzPar5Data(null)

        newItem.id = item.id
        newItem.parent = item.parent
        newItem.prijmy_pp = item.prijmy_pp
        newItem.pr_dohoda = item.pr_dohoda
        newItem.soc_poist = item.soc_poist
        newItem.zdrav_poist = item.zdrav_poist
        newItem.bonus = item.bonus
        newItem.dan35 = item.dan35

        this.tuzemskePar5.push(newItem)
      })
    }
  }
}
</script>

<style>
.p12 .form-check {
    width: 12%;
}
.item-title {
    margin-top: 3.5%;
    text-align: right;
    font-weight: bold;
}
.pull-right {
    float: right;
}
.add-item {
    float: left;
}
</style>
